import { IAPIRoutes } from "../../../../config";

export type IMedicationReconciliationRepository = ReturnType<
  typeof MedicationReconciliationRepositoryFactory
>;

export const MedicationReconciliationRepositoryFactory = ({
  APIProvider,
  AuthService,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, POST, PATCH } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const uploadDischargePdfAPI: IUploadDischargePdfAPI = async (payload) => {
    const formData = new FormData();
    formData.append("patient_id", payload.patient_id.toString());
    formData.append("file", payload.file);

    return POST(
      APIRoutes.apiUploadDischargePdf.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      formData,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
        // Don't set Content-Type for FormData, let the browser set it with boundary
      }
    );
  };

  const getDischargePdfUploadsAPI: IGetDischargePdfUploadsAPI = async (
    payload
  ) => {
    const queryParams: Record<string, any> = {
      patient_id: payload.patient_id,
    };
    if (payload.limit !== undefined) {
      queryParams.limit = payload.limit;
    }
    return GET(
      APIRoutes.apiGetDischargePdfUploads.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      queryParams,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const getMedRecAdmissionsAPI: IGetMedRecAdmissionsAPI = async (payload) => {
    const queryParams: Record<string, any> = {};
    if (payload.no_of_days !== undefined && payload.no_of_days !== null) {
      queryParams.no_of_days = payload.no_of_days;
    }
    return GET(
      APIRoutes.apiGetMedRecAdmissions.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      queryParams,
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  const updateFindingStatusAPI: IUpdateFindingStatusAPI = async (payload) => {
    return PATCH(
      APIRoutes.apiUpdateFindingStatus
        .replace("{clinic_id}", payload.clinic_id.toString())
        .replace("{upload_id}", payload.upload_id.toString())
        .replace("{finding_index}", payload.finding_index.toString()),
      { status: payload.status },
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
  };

  return {
    uploadDischargePdfAPI,
    getDischargePdfUploadsAPI,
    getMedRecAdmissionsAPI,
    updateFindingStatusAPI,
  };
};
